<template>
  <i-modal
    :title="$t(edit ? 'editing' : 'add', { value: $tc('globaltax', 1) })"
    :value="value"
    :load="loading"
    @submit="submit"
    @input="$emit('input', $event)"
  >
    <v-row>
      <v-col cols="12">
        <ValidationProvider
          vid="name"
          :name="$tc('name', 1)"
          rules="required"
          v-slot="{ errors }"
        >
          <v-text-field
            autofocus
            name="name"
            :error-messages="errors[0]"
            v-model="tax.name"
            outlined
            color="secondary"
            :label="$tc('name', 1)"
          />
        </ValidationProvider>
      </v-col>
      <v-col cols="12">
        <ValidationProvider
          vid="percent"
          :name="$tc('percent', 1)"
          rules="required|double:2"
          v-slot="{ errors }"
        >
          <v-text-field
            name="percent"
            outlined
            :error-messages="errors[0]"
            v-model="tax.percent"
            color="secondary"
            :label="$tc('percent', 1)"
            type="number"
            step="0.01"
          />
        </ValidationProvider>
      </v-col>
    </v-row>
  </i-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: [Object],
      default: () => null
    },
    company: {
      type: Number,
      default: () => null
    }
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      tax: {
        name: '',
        percent: 0,
        company: null
      },
      edit: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.edit = this.toEdit !== null
          this.tax =
            this.toEdit !== null
              ? { ...this.toEdit }
              : { name: '', percent: '0.00', company: this.company }
        }
      }
    }
    // 'tax.percent': {
    //   handler(val) {
    //     this.tax.percent = Number(val).toFixed(2)
    //   }
    // }
  },
  methods: {
    async submit() {
      if (!this.loading) {
        try {
          this.loading = true
          !this.edit
            ? await this.$api.tax.create({ form: this.tax })
            : await this.$api.tax.edit({
                pk: this.tax.pk,
                form: this.tax
              })
          this.$emit('done')
          this.$emit('input', false)
          this.$toast.success(
            `${this.$tc('globaltax', 1)} ${this.$tc(
              this.edit ? 'edited' : 'created',
              1
            )}`
          )
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
